export const QUOTE_PEER_QUOTES_PREVIEW_LIMIT = 10;
